import { useState, } from "react";

import { getOrders, getOrder, commitOrder, getCommitmentSummary as fetchCommitmentSummary, getCommitmentByOrder, updateOrder, deleteCommitment } from "../apiPromises/jobsApi";

const useJobs = () => {
  return () => {
    const [jobs, setJobs] = useState([]);
    const [commitment, setCommitment] = useState([]);
    const [jobDetail, setJobDetail] = useState({});
    const [commitmentSummary, setcommitmentSummary] = useState({});

    const getJobs = (orderStatus, userCommitted, userCommitmentFulfilled) => {
      return getOrders(orderStatus, userCommitted, userCommitmentFulfilled).then(res => {
        setJobs(res.data);
      }).catch(err => console.error('Error getting jobs from the server'))
    };

    const getJob = (id) => {
      return getOrder(id).then(res => {
        setJobDetail(res.data);
      })
    };

    const getPending = () => {
      return getPending();
    }

    const getCommitmentSummary = () => {
      return fetchCommitmentSummary().then(res => {
        setcommitmentSummary(res.data);
      }).catch(err => console.error('Error retrieving commitment summary from server'))
    }

    const commitJob = (id, amount, lat, long) => {
      return commitOrder(id, amount, lat, long);
    }

    const updateJob = (orderId, commitmentId, amount, lat, long) => {
      return updateOrder(orderId, commitmentId, amount, lat, long);
    }

    const getCommitmentByJobId = (id) => {
      return getCommitmentByOrder(id)
        .then(res => {
          setCommitment(res.data.data);
        });
    }

    return {
      state: {
        jobs,
        jobDetail,
        commitment,
        commitmentSummary
      },
      getJobs,
      getJob,
      commitJob,
      updateJob,
      getCommitmentByJobId,
      getCommitmentSummary,
      deleteCommitment
    };
  };
};

export default useJobs;
